import { jsxs as i, jsx as s } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import n from "./index.es821.js";
import { Chip as d } from "./index.es34.js";
const l = "chip-group-component", G = f(
  ({ chips: o, children: r, testId: t = l, size: m = "small" }, p) => /* @__PURE__ */ i("div", { "data-testid": t, className: n.chipGroup, ref: p, children: [
    o == null ? void 0 : o.map(({ key: e, ...a }) => /* @__PURE__ */ s(d, { ...a, size: m }, e)),
    r
  ] })
);
export {
  l as CHIP_GROUP_DEFAULT_TESTID,
  G as ChipGroup
};
//# sourceMappingURL=index.es35.js.map
